/* BD HERBS — lightweight scroll-snap carousel, shared by every homepage list.
   Native swipe on touch; prev/next buttons scroll one "page" of cards on desktop;
   an optional [data-progress] line shows how far the list is scrolled. */
if (!customElements.get('bd-carousel')) {
  customElements.define(
    'bd-carousel',
    class BdCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.prevButton = this.querySelector('[data-prev]');
        this.progress = this.querySelector('[data-progress]');
        this.nextButton = this.querySelector('[data-next]');

        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();

        // Listeners only once: the theme editor moves sections around (disconnect + connect)
        if (this.bound) return;
        this.bound = true;

        this.prevButton?.addEventListener('click', () => this.go(-1));
        this.nextButton?.addEventListener('click', () => this.go(1));
        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.update());
          },
          { passive: true }
        );
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      stepSize() {
        const item = this.track.firstElementChild;
        if (!item) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      go(direction) {
        const step = this.stepSize();
        const perView = Math.max(1, Math.floor((this.track.clientWidth + 1) / step));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * step * perView, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = scrollWidth - clientWidth - 2;
        this.toggleAttribute('data-overflowing', max > 0);
        if (this.progress && scrollWidth > 0) {
          this.progress.style.setProperty('--bd-progress-size', Math.min(1, clientWidth / scrollWidth).toFixed(3));
          this.progress.style.setProperty('--bd-progress-pos', max > 0 ? Math.min(1, Math.max(0, scrollLeft / max)).toFixed(3) : '0');
        }
        if (this.prevButton) this.prevButton.disabled = scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = scrollLeft >= max;
      }
    }
  );
}
